import { Flex, Text } from "@radix-ui/themes";

type NavButtonProps = {
  title: string;
  icon: React.ReactNode;
  isActive?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  "data-testid"?: string;
};

export default function NavButton({
  title,
  icon,
  isActive,
  onClick,
  disabled,
  "data-testid": dataTestId,
}: NavButtonProps) {
  return (
    <Flex
      onClick={onClick}
      direction="row"
      data-testid={dataTestId}
      /* pl matches the Create button above, so every icon in the sidebar sits
         on the same vertical line. */
      className={`items-center h-[35px] gap-[8px] w-full pl-[16px] text-[14px] rounded-[5px] text-text-secondary fill-text-secondary cursor-pointer hover:bg-background-quarternary transition-all hover:text-brand-primary ${isActive ? "bg-background-quarternary !text-brand-primary" : ""} ${disabled && "opacity-[0.5]"}`}
    >
      {icon}
      <Text className="font-semibold">{title}</Text>
    </Flex>
  );
}
